import React from 'react';
import BasketPaxDetails from './basketPaxDetails';
import BasketBooking from './basketbooking';
import { LOCKOUT_MESSAGES } from '../../config';
import { strCount } from '../../helpers/stringUtils';

let BasketDeparture = props => {

  const renderLockoutBox = (lockout) => {

    if(!lockout) return null;

    return (
      <div className="lockout-box" style={{display: props.lockout ? "block" : "none" }}>
        <h5 className="orange-text text-initial">
          <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76.001" viewBox="0 0 76 76.001">
          <g>
            <g>
              <path d="M38 58a2 2 0 0 1-2-2v-6.902a2 2 0 0 1 4 0V56a2 2 0 0 1-2 2z"/>
              <path d="M47 58H29a2 2 0 0 1 0-4h18a2 2 0 0 1 0 4zM38 29.334a6.5 6.5 0 1 1 6.5-6.5 6.508 6.508 0 0 1-6.5 6.5zm0-9a2.5 2.5 0 1 0 2.5 2.5 2.502 2.502 0 0 0-2.5-2.5zM38 43.598a2 2 0 0 1-2-2v-5.195h-5.195a2 2 0 0 1 0-4H38a2 2 0 0 1 2 2v7.195a2 2 0 0 1-2 2z"/>
              <path d="M38 76a38 38 0 1 1 38-38 38.043 38.043 0 0 1-38 38zm0-72a34 34 0 1 0 34 34A34.038 34.038 0 0 0 38 4z"/>
            </g>
          </g>
        </svg>
        {LOCKOUT_MESSAGES['passengerDetailsTitle']}
        </h5>
        <p className="no-margin" dangerouslySetInnerHTML={{ __html:LOCKOUT_MESSAGES['passengerDetailsText'] }}></p>
      </div>
    )
    
  }
  

  return (

    <React.Fragment>
      
      { renderLockoutBox(props.lockout) }

      <div className={`basket-departure ${props.basketType}`}>
        <h3 className={`busabout-h3 no-margin ${strCount(props.headerText, 44, 'small-text')}`}>{props.headerText}</h3>
        <p className="bold no-margin viking-text" style={{ display: (props.upgradesName  === "" || props.upgradesName  === undefined) ? 'none': 'inline-block' }}> + { props.upgradesName }</p>
        <p className="bold component-spacing">Price from <span className="orange-text">{props.headerCurrency}{props.headerPrice}</span> per person.</p>
        <BasketPaxDetails nationality={props.nationality} basketType={props.basketType} />
        <BasketBooking basketType={props.basketType}/>
      </div>

    </React.Fragment>
  )
}

export default React.memo(BasketDeparture);


// WEBPACK FOOTER //
// ./src/components/basket/basketdeparture.js